import { render } from "./ProfileCropper.vue?vue&type=template&id=bd7d5ec6"
import script from "./ProfileCropper.vue?vue&type=script&lang=js"
export * from "./ProfileCropper.vue?vue&type=script&lang=js"
script.render = render

export default script